// extracted by mini-css-extract-plugin
export default {"contacts-btn":"styles_contacts-btn__cmC3e","icon":"styles_icon__1-Ubr"};